<section id="services" class="services-section">
  <div class="container">
    <div class="section-head text-center">
      <h2>our services</h2>
      <p>Complete garment care for your everyday laundry and specialty items.</p>
    </div>

    <div class="row services-grid">
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">dry_cleaning</mat-icon>
          <h3>dry cleaning</h3>
          <p>Professional cleaning for delicate fabrics and structured garments.</p>
        </div>
      </div>
      
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">local_laundry_service</mat-icon>
          <h3>wash & fold</h3>
          <p>Everyday laundry washed, folded, and ready for your week.</p>
        </div>
      </div>
      
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">king_bed</mat-icon>
          <h3>comforters</h3>
          <p>Fabric-safe cleaning for comforters, quilts, duvets, and other bedding cloth items.</p>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">checkroom</mat-icon>
          <h3>wedding gown care</h3>
          <p>Specialized attention for bridal gowns and delicate formalwear.</p>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">content_cut</mat-icon>
          <h3>alterations</h3>
          <p>Precise tailoring adjustments for a better fit and finish.</p>
        </div>
      </div>
    </div>
  </div>
</section>
